interface TelegramWebApp {
  ready: () => void;
  expand: () => void;
  initData: string;
  themeParams: Record<string, string>;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export function isTelegramWebApp(): boolean {
  return typeof window !== 'undefined' && !!window.Telegram?.WebApp?.initData;
}

export function telegramInitData(): string | null {
  return window.Telegram?.WebApp?.initData || null;
}

export function telegramReady(): void {
  const tg = window.Telegram?.WebApp;
  if (!tg) return;
  tg.ready();
  try {
    tg.expand();
  } catch {
    // ignore
  }
}
